import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { LinkModule } from '../link/link.module';
import { VersionsComponent } from './versions/versions.component';
import { VersionsService } from './versions.service';


@NgModule({
  imports: [
    CommonModule,
    LinkModule,
  ],
  declarations: [
    VersionsComponent,
  ],
  exports: [
    VersionsComponent,
   ],
  providers: [VersionsService, DatePipe]
})
export class VersionsModule {}
